"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function vdlPrefix(className) {
    if (process.env.VDL_PREFIX == null) {
        return 'vdl-' + className;
    }
    else {
        return process.env.VDL_PREFIX + className;
    }
}
exports.vdlPrefix = vdlPrefix;
